import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';

const buttonLikeCss = css`
  text-decoration: none;
  border: none;
  vertical-align: middle;
  cursor: pointer;
  transition: filter 0.2s ease, background-color 0.2s ease;

  &:disabled {
    cursor: not-allowed;

    &:hover {
      filter: brightness(100%);
    }
  }

  &:hover {
    filter: brightness(90%);
  }

  &:focus {
    outline: none;
  }

  flex: 0 1 auto;
  border: none;
  border-radius: ${rem(4)};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.color.white};
  font-family: ${({ theme }) => theme.font.secondary};
  height: ${rem(48)};

  font-family: 'Roboto', sans-serif;
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0;

  justify-content: center;
  display: flex;
  align-items: center;

  padding: ${rem(8)} ${rem(32)} ${rem(8)} ${rem(32)};

  ${({ theme }) => theme.mediab.s450`
    display: flex;
    width: 100%;
    /*height: initial;*/
  `}

  &:disabled {
    background: gray;
    color: white;
  }
`;

export const Button: any = styled.button`
  ${buttonLikeCss}
`;

export const ButtonLink: any = styled(Link)`
  ${buttonLikeCss};
  text-align: center;
`;

export const ButtonPrimary: any = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const ButtonPrimaryLink: any = styled(ButtonLink)`
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const ButtonSecondary: any = styled(Button)`
  text-transform: none;
  color: ${({ theme }) => theme.colors.primary};
  border: ${rem(2)} solid ${({ theme }) => theme.colors.primary};
  font-weight: 400;
  height: initial;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${rem(6)} ${rem(43)} ${rem(7)} ${rem(43)};
`;

export const ButtonSecondaryLink: any = styled(ButtonLink)`
  text-transform: none;
  color: ${({ theme }) => theme.colors.primary};
  border: ${rem(2)} solid ${({ theme }) => theme.colors.primary};
  font-weight: 400;
  height: initial;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${rem(6)} ${rem(43)} ${rem(7)} ${rem(43)};
`;

export const ButtonTertiary: any = styled(Button)`
  color: ${({ theme }) => theme.colors.black};
  /* background-color: rgba(57, 98, 168, 0.04); */
  background-color: transparent;
  position: relative;
  overflow: hidden;

  &:hover,
  &:focus {
    &::before {
      opacity: 0.1;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.tertiary};
    opacity: 0.04;
    z-index: 0;
  }
`;

export const ButtonTertiaryLink: any = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.black};
  /* background-color: rgba(57, 98, 168, 0.04); */
  background-color: transparent;
  position: relative;
  overflow: hidden;

  &:hover,
  &:focus {
    &::before {
      opacity: 0.1;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.tertiary};
    opacity: 0.04;
    z-index: 0;
  }
`;

export const ButtonFourthLink: any = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.tertiaryBackground};
  width: 100%;
  max-width: ${rem(260)};
`;
